// FieldAllowMultipleField.jsx

import React from 'react';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * FieldAllowMultipleField
 *
 * Toggle for Relation single vs multi selection.
 *
 * @returns {ReactNode} The rendered control.
 */
const FieldAllowMultipleField = ({
  allowMultiple,
  onAllowMultipleChange,
}) => (

  <ModalField>

    <ModalLabel label="Allow Multiple" />
    <ModalHint hint="When unchecked, this field is a single select of records from the target database." />

    <Checkbox
      value={allowMultiple !== false}
      size="22"
      label="Allow multiple selections"
      onChange={() => onAllowMultipleChange(!(allowMultiple !== false))}
    />

  </ModalField>

);

// Dev Tools
FieldAllowMultipleField.displayName = 'FieldAllowMultipleField';

export default FieldAllowMultipleField;
